import React from "react";

import Franco from "./static/Images/Pro.png";
import FacebookIcon from "./static/Icons/icon-facebook.png";
import PhoneIcon from "./static/Icons/icon-phone.png";
import GmailIcon from "./static/Icons/icon-gmail.png";

import "./App.scss";

function App() {
  return (
    <div className="contentBase">
      <div className="profile">
        <img src={Franco} alt="Personal_picture" />
      </div>
      <div className="links">
        <ul>
          <li>
            <div>
              <div>
                <img src={PhoneIcon} alt="Phone" />
              </div>
              <ul>
                <li>+261 32 73 509 21</li>
                <li>+261 34 98 177 95</li>
                <li>+261 34 01 095 43</li>
              </ul>
            </div>
          </li>
          <li>
            <a href="mailto:jean.franco.ratovoson@gmail.com">
              <div>
                <div>
                  <img src={GmailIcon} alt="Gmail" />
                </div>
                <div>jean.franco.ratovoson@gmail.com</div>
              </div>
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/RatovosonJeanFranco/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <div>
                  <img src={FacebookIcon} alt="Facebook" />
                </div>
                <div>Franco Ratovoson</div>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default App;
